import { routesPaths } from "../Routes";

export default class UrlHelper {

    public static pathUrl(path: string): string {
        return `${window.location.protocol}//${window.location.host}${path}`;
    }

    public static loginUrl(): string {
        return `${window.location.protocol}//${window.location.host}${routesPaths.login()}`;
    }

    public static getMyVbvUrl(): string {
        if (window.location.href.includes("localhost")) {
            return "https://vbv-lernwelt.control.iterativ.ch";
        }
        if (window.location.href.includes("dev-edumgr")) {
            return "https://vbv-lernwelt.control.iterativ.ch";
        }
        if (window.location.href.includes("tst-edumgr")) {
            return "https://myvbv-stage.iterativ.ch";
        }
        return "https://my.vbv-afa.ch";
    }
}

